module.exports = __webpack_public_path__ + "static/media/GOOGLE_POLISH_FEMALE3.3bcd48c5.mp3";